import { defineMessages } from 'react-intl';

export default defineMessages({
  diagmatic: 'Diagmatic',
  system: 'System',
});
